<template>
  <div class="social-share">
    <social-icons-loader v-if="!linkMade" />
    <div
      v-if="linkMade"
      class="social-icons">
      <div class="desktop hidden-xs-only">
        <a
          :href="facebookLink"
          rel="noopener noreferrer"
          target="_blank"
          class="social-icon social-icon-fb"
          data-test="link-facebook"
          @click="contentShareEvent">
          <img src="../assets/images/share_facebook_original.svg" >
        </a>
        <a
          :href="twitterLink"
          rel="noopener noreferrer"
          target="_blank"
          class="social-icon social-icon-twitter"
          data-test="link-twitter"
          @click="contentShareEvent">
          <img src="../assets/images/share_twitter_original.svg" >
        </a>
        <a
          :href="mailLink"
          rel="noopener noreferrer"
          class="social-icon social-icon-email"
          data-test="link-mail"
          @click="contentShareEvent">
          <svg class="svg-with-hover" svg-inline="" height="24px" width="24px" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="white" d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V8L12 13L20 8V18ZM12 11L4 6H20L12 11Z"/></svg>
        </a>
        <a
          rel="noopener noreferrer"
          class="social-icon social-icon-copy"
          data-test="link-copy"
          @click="onCopy">
          <svg class="svg-with-hover" svg-inline="" height="24px" width="24px" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="black" fill-rule="evenodd" d="M11.9997 8.56885C11.5263 9.04228 10.7577 9.04228 10.2843 8.56885C9.81001 8.09457 9.81001 7.32687 10.2843 6.85259L13.716 3.4209C15.6105 1.52637 18.683 1.52637 20.5785 3.4209C22.4738 5.31629 22.4738 8.38883 20.5785 10.2843L17.1468 13.7151C16.6734 14.1894 15.9048 14.1894 15.4314 13.7151C14.9579 13.2417 14.9579 12.474 15.4314 11.9997L18.8631 8.568C19.8099 7.62117 19.8099 6.08491 18.8631 5.13718C17.9154 4.1895 16.3791 4.1895 15.4314 5.13718L11.9997 8.56885ZM11.9997 15.4314C12.474 14.9571 13.2417 14.9571 13.7159 15.4314C14.1894 15.9048 14.1894 16.6733 13.7159 17.1468L10.2843 20.5785C8.38888 22.4738 5.31635 22.4738 3.4209 20.5785C1.52637 18.6831 1.52637 15.6105 3.4209 13.716L6.85258 10.2843C7.32686 9.81084 8.09456 9.81084 8.56799 10.2843C9.04226 10.7577 9.04226 11.5262 8.56799 11.9997L5.13718 15.4314C4.1895 16.379 4.1895 17.9153 5.13718 18.863C6.08486 19.8099 7.62114 19.8099 8.56799 18.863L11.9997 15.4314ZM15.4314 8.56798C15.9048 9.04226 15.9048 9.80996 15.4314 10.2842L10.2844 15.4312C9.81097 15.9047 9.04242 15.9047 8.56899 15.4312C8.09471 14.9569 8.09471 14.1892 8.56899 13.715L13.716 8.56798C14.1894 8.09455 14.9579 8.09455 15.4314 8.56798Z" clip-rule="evenodd"/><mask id="share_link_white_svg__a" width="20" height="20" x="2" y="2" maskUnits="userSpaceOnUse"><path fill="white" fill-rule="evenodd" d="M11.9997 8.56885C11.5263 9.04228 10.7577 9.04228 10.2843 8.56885C9.81001 8.09457 9.81001 7.32687 10.2843 6.85259L13.716 3.4209C15.6105 1.52637 18.683 1.52637 20.5785 3.4209C22.4738 5.31629 22.4738 8.38883 20.5785 10.2843L17.1468 13.7151C16.6734 14.1894 15.9048 14.1894 15.4314 13.7151C14.9579 13.2417 14.9579 12.474 15.4314 11.9997L18.8631 8.568C19.8099 7.62117 19.8099 6.08491 18.8631 5.13718C17.9154 4.1895 16.3791 4.1895 15.4314 5.13718L11.9997 8.56885ZM11.9997 15.4314C12.474 14.9571 13.2417 14.9571 13.7159 15.4314C14.1894 15.9048 14.1894 16.6733 13.7159 17.1468L10.2843 20.5785C8.38888 22.4738 5.31635 22.4738 3.4209 20.5785C1.52637 18.6831 1.52637 15.6105 3.4209 13.716L6.85258 10.2843C7.32686 9.81084 8.09456 9.81084 8.56799 10.2843C9.04226 10.7577 9.04226 11.5262 8.56799 11.9997L5.13718 15.4314C4.1895 16.379 4.1895 17.9153 5.13718 18.863C6.08486 19.8099 7.62114 19.8099 8.56799 18.863L11.9997 15.4314ZM15.4314 8.56798C15.9048 9.04226 15.9048 9.80996 15.4314 10.2842L10.2844 15.4312C9.81097 15.9047 9.04242 15.9047 8.56899 15.4312C8.09471 14.9569 8.09471 14.1892 8.56899 13.715L13.716 8.56798C14.1894 8.09455 14.9579 8.09455 15.4314 8.56798Z" clip-rule="evenodd"/></mask><g mask="url(#share_link_white_svg__a)"><rect width="24" height="24" fill="white"/></g></svg>
        </a>
        <input
          id="copy-link"
          :value="copyLink"
          type="hidden">
      </div>
      <div class="mobile hidden-sm-and-up">
        <div @click="openMobileSharePane">
          <img src="../assets/images/share_mobile.svg" >
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :before-close="handleClose"
      title="Tips"
      width="30%"
      custom-class="mobile-share-pane-dialog">
      <div class="pane">
        <a
          :href="facebookLink"
          rel="noopener noreferrer"
          target="_blank"
          class="pane-item social-icon-fb"
          data-test="link-facebook"
          @click="contentShareEvent">
          <img src="../assets/images/share_facebook_original.svg" >
          Facebook
        </a>
        <a
          :href="twitterLink"
          rel="noopener noreferrer"
          target="_blank"
          class="pane-item social-icon-twitter"
          data-test="link-twitter"
          @click="contentShareEvent">
          <img src="../assets/images/share_twitter_original.svg" >
          Twitter
        </a>
        <a
          :href="mailLink"
          rel="noopener noreferrer"
          class="pane-item social-icon-email"
          data-test="link-mail"
          @click="contentShareEvent">
          <img src="../assets/images/share_email_black.svg" >
          Email
        </a>
        <a
          rel="noopener noreferrer"
          class="pane-item social-icon-copy"
          data-test="link-copy"
          @click="onCopy">
          <img src="../assets/images/share_link_black.svg" >
          Copy Link
        </a>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <div class="pane">
          <div
            class="pane-item cancel-btn"
            @click="dialogVisible = false">Cancel</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as log from 'loglevel';
import Branch from '../services/Branch';

export default {
  components: {
    SocialIconsLoader: () => import('./loaders/SocialIconsLoader'),
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    showData: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      linkData: null,
      linkMade: false,
      branch_service: new Branch(),
      dialogVisible: false,
    };
  },
  computed: {
    links() {
      return (this.linkData && this.linkData.links) || {};
    },
    link() {
      return this.links.default;
    },
    facebookLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.links.facebook}`;
    },
    twitterLink() {
      return `https://twitter.com/intent/tweet?url=${this.links.twitter}`;
    },
    mailLink() {
      return `mailto:?subject=${this.showData.title}&body=${this.link}`;
    },
    copyLink() {
      return `${this.link}`;
    },
    smsLink() {
      return `sms:?body=${this.link}`;
    },
  },
  beforeMount() {
    this.createSharingLink();
  },
  methods: {
    createSharingLink() {
      if (!this.showData || !this.showData.uuid) return;
      this.linkMade = false;
      this.branch_service.createLink(this.type, this.showData.uuid).then((resp) => {
        this.linkData = resp;
      }).catch((error) => {
        log.info(error.message);
      }).finally(() => {
        this.linkMade = true;
      });
    },
    close() {
      this.$emit('close');
    },
    onCopy() {
      const copyLink = document.querySelector('#copy-link');
      copyLink.setAttribute('type', 'text');
      copyLink.select();

      try {
        document.execCommand('copy');
        this.showSuccessMsg('Link copied!');
      } catch (git) {
        this.showErrorMsg('Failed to copy link');
      }

      copyLink.setAttribute('type', 'hidden');
      this.contentShareEvent();
    },
    mail() {
      log.info('Mail');
    },
    contentShareEvent() {
      const data = {};
      if (this.type === 'podcast') {
        data.content_type = 'podcast';
        data.content_uuid = this.showData.uuid;
        data.podcast_uuid = this.showData.uuid;
        data.podcast_exclusive = this.showData.is_exclusive;
        data.podcast_title = this.showData.title;
      } else if (this.type === 'episode') {
        data.content_type = 'episode';
        data.content_uuid = this.showData.uuid;
        data.podcast_uuid = this.showData.season.podcast.uuid;
        data.podcast_exclusive = this.showData.podcast_is_exclusive;
        data.podcast_title = this.showData.season.podcast.title;
      }
      this.$analytics.track('content_share', data);
    },
    openMobileSharePane() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss">
@import '../assets/scss/variables.scss';
.social-share {
  @media (max-width: 767px) {
    margin-top: 10px;
  }
  @media (max-width: 567px) {
    margin-top: 0px;
  }
  .svg-with-hover:hover {
    path,
    rect {
      fill: $blue;
    }
  }
  .social-icons {
    .desktop {
      .social-icon {
        cursor: pointer;
        display: inline-block;
        position: relative;
        margin-right: 24px;

        &:last-of-type {
          margin-right: 0;
        }
      }
    }

    .mobile {
      display: block;
    }

    .social-icon-fb { // images are not all same size and different bounding boxes
      top: -2px;
    }
    .social-icon-copy { // images are not all same size and different bounding boxes
      top: -2px;
    }
  }
  .mobile-share-pane-dialog {
    width: 95% !important;
    height: 52vh;
    top: 48vh;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    background: transparent;
    .el-dialog__body, .el-dialog__footer {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 8px;
      .pane {
        text-align: left;
        background-color: rgba(248, 248, 248, 0.92);
        border-radius: 14px;
        &-item {
          display: block;
          color: $black;
          padding: 16px 18px;
          border-bottom: 1px solid $gray;
          font-size: 20px;
          line-height: 25px;
          letter-spacing: 0.38px;
          img {
            margin-right: 8px;
          }
          &.cancel-btn {
            color: #007AFF;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
